import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals';

/**
 * Reports Core Web Vitals (CLS, INP, LCP, FCP, TTFB) to Sentry as custom
 * measurements. Only runs in production where Sentry is initialised.
 */
@Injectable({ providedIn: 'root' })
export class WebVitalsService {
  report(): void {
    const send = ({ name, value, id }: { name: string; value: number; id: string }) => {
      Sentry.getCurrentScope().addBreadcrumb({
        category: 'web-vitals',
        message: `${name}: ${Math.round(name === 'CLS' ? value * 1000 : value)} (${id})`,
        level: 'info',
      });

      const activeSpan = Sentry.getActiveSpan();
      if (activeSpan) {
        Sentry.setMeasurement(name, value, name === 'CLS' ? 'none' : 'millisecond');
      }
    };

    onCLS(send);
    onINP(send);
    onLCP(send);
    onFCP(send);
    onTTFB(send);
  }
}
